import './Clips.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"

const Clips = observer(
  class Clips extends Component {
    state={
      clips: [],
    }


		componentDidMount = () => {
			this.props.flow.cccmylog('Clips -> didmount ');
			// this.props.reloadcb();
		}

    constructor(props) {
      super(props);
      // data from props or get via id
      if (props.article)
        this.state.clips = props.article.getClips();
      else
        console.error('Clip expects attribute "article".');
    }
		
		delClip = (id)=>{
			this.props.flow.delClip(id).then(res=>this.postdelclip());
		}
		
		postdelclip = ()=>{
			this.props.reloadcb();
		}
		
    render() {
			let results = this.state.clips.elements.map(cl=>{
				return <Clip delcb={ this.delClip } key={ cl.getId() } clip={ cl } />
			})
      return (
				<>
					<div className="cliplist">
						{results}
					</div><br />
				</>
      );
    }

  }
)

function Clip(props) {
	
	let clid = props.clip.getId();
	let thumbcomp = null;
	let mainthumb = props.clip.getMainthumbnail();
	if(mainthumb != null && mainthumb.data && mainthumb.data.url) {
		thumbcomp = <img alt="thumb" src={'https:'+mainthumb.data.url} />
	}
	let delknob = <div onClick={()=>{ props.delcb(clid) }} className="listclipdelete">x</div>;    
	if(typeof(props.clip.data.metadata.fields.txt1) == 'string' && props.clip.data.metadata.fields.txt1.indexOf('public') > -1)
		delknob = null;
	return (
		<div className="cliplistitem">
			<div className="listcliptthumb">
			{thumbcomp}
			</div>
			<div className="listclipmeta">
				{delknob}
				<div className="listcliptitle">{ props.clip.getMetadata().get('title') }</div>
				<div className="listcliptitle">{ props.clip.getMetadata().get('uploader') }</div>
			</div>
		</div>
	)
}


export default Flow.injectFlow(Clips);